import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sofax/hero-1-element-2.svg")